import {
    Component,
    Input,
    Inject,
    NgZone,
    ChangeDetectorRef,
    ViewChild,
    AfterViewChecked,
} from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Actions, Select, Store, ofActionSuccessful } from "@ngxs/store";
import {
    LookupModel,
    TourModel,
    UpdateTypeConnectionsModel,
    UpdateTypeModel,
    UserModel,
    VehicleTypesSpeedModel,
} from "@core/services/api.service";
import { UpdateTypeState } from "@ngxs-store/update-type-store/update-type.state";
import {
    Observable,
} from "rxjs";
import { take } from "rxjs/operators";
import {
    LoadUpdateTypesAction,
    LoadUpdateTypesByParentIdAction,
} from "@ngxs-store/update-type-store/update-type.actions";
import {
    AuditGoogleApiAction,
    CalculateDistanceAction,
    CalculateDistanceSuccessAction,
    CreateTourHistoryByTourIdAction,
    GetTourByIdAction,
    LoadTourListAction,
    LogAnIssueAction,
    SaveRouteAction,
    UpdateETAAction,
    UpdateETASuccessAction,
    UpdateHistoryItemByIdAction,
    ClearSelectedTourAction,
} from "@ngxs-store/managed-tour-store/managed-tour.actions";
import { MapsAPILoader } from "@agm/core";
import { FormControl } from "@angular/forms";
import { AssignVehicleDialogComponent } from "../assign-vehicle-dialog/assign-vehicle-dialog.component";
import { HttpClient } from "@angular/common/http";
import { UsersState } from "@ngxs-store/users-store/users.state";
import { GetVehicleSpeedByTypeAction } from "@ngxs-store/vehicles-store/vehicles.action";
import { VehiclesState } from "@ngxs-store/vehicles-store/vehicles.state";
import { ConfirmationDialogComponent } from "../confirmation-dialog/confirmation-dialog.component";
import { LoadDashboardsAction } from "@ngxs-store/dashboards-store/dashboards.actions";
import { LookupState } from "@ngxs-store/lookup-store/lookup.state";
import {
    LoadGetCauseOfIssueUpdateTypesAction,
    LoadGetCauseOfIssueUpdateTypesSuccessAction,
    LoadGetImpactUpdateTypesAction,
    LoadGetImpactUpdateTypesSuccessAction,
    LoadGetReasonForIssueUpdateTypesAction,
    LoadGetReasonForIssueUpdateTypesSuccessAction,
} from "@ngxs-store/lookup-store/lookup.actions";
import { AuthState } from "@ngxs-store/auth-store/auth.state";
import { UpdateCustomByTourIdAction } from "@ngxs-store/customs-store/customs.actions";
import { EditContactPersonDialogComponent } from "../edit-contact-person-dialog/edit-contact-person-dialog.component";

@Component({
    selector: "app-update-eta-dialog",
    templateUrl: "./update-eta-dialog.html",
    styleUrls: ["./update-eta-dialog.scss"],
})
export class UpdateEtaDialogComponent implements AfterViewChecked {
    @ViewChild("map") mapElement: any;
    map: google.maps.Map | undefined;
    marker: google.maps.Marker | undefined;
    @Select(UpdateTypeState.getUpdateTypes) updateTypes$: Observable<
        UpdateTypeModel[]
    >;
    @Select(LookupState.getCauseOfIssueUpdateTypes)
    causeOfIssueTypes$: Observable<LookupModel[]>;
    @Select(LookupState.getImpactUpdateTypes) impactTypes$: Observable<
        LookupModel[]
    >;
    @Select(LookupState.getReasonForIssueUpdateTypes)
    reasonForIssueTypes$: Observable<LookupModel[]>;
    @Select(UpdateTypeState.getUpdateTypeConnections)
    updateTypesConnections$: Observable<UpdateTypeConnectionsModel[]>;
    @Select(UsersState.getUsers) users$: Observable<UserModel[]>;
    @Select(VehiclesState.getVehicleSpeedByTypeAction)
    vehicleTypeSpeed$: Observable<VehicleTypesSpeedModel>;
    @Input() vehicleTypeSpeed: VehicleTypesSpeedModel;
    @Input() updateTypes: UpdateTypeModel[];
    @Input() updateTypeConnection: UpdateTypeConnectionsModel[];
    @Input() tourId: number;
    @Input() amcoId: number;
    @Input() id: number;
    @Input() tour: TourModel;
    @Input() causeOfIssueTypes: LookupModel[];
    @Input() impactTypes: LookupModel[];
    @Input() reasonForIssueTypes: LookupModel[];
    polylinePoints: Array<{ lat: number; lng: number }> = [];
    searchControl: FormControl;
    searchLatLng: FormControl;
    causeOfIssueTypesList: LookupModel[];
    impactTypesList: LookupModel[];
    reasonForIssueTypesList: LookupModel[];
    causeOfIssue: string;
    issueStatus: string = "open";
    priority: string = "low";
    impactType: string;
    reasonForIssueType: string;
    valid = false;
    private inputLocationLoaded = false;
    places: any;
    selectedDate: Date;
    restStartDate: Date;
    restEndDate: Date;
    restStartTargetTime: string;
    restEndTargetTime: string;
    targetDate: string;
    targetDates: string;
    targetTime: string;
    targetDateOnly: Date;
    plannedDeliveryStart: string;
    plannedDeliveryEnd: string;
    plannedLoadingStart: string;
    plannedLoadingEnd: string;
    updateType: number = null;
    addDates = true;
    addReason = true;
    issueRaisedByCustomer: boolean = false;
    hasCustomerBeenCalled: any = null;
    hasCarrierBeenCalled: any = null;
    escalateIssue: boolean = false;
    addNotes = true;
    addRestDates = false;
    showCalBtn = false;
    showDelDates = true;
    addInputLocation = false;
    hasVehicle = false;
    updateTypeId: any;
    updateTypeName: any;
    note: string = "";
    managerActions: string = "";
    issueActions: string = "";
    latitude: number;
    longitude: number;
    zoom = 15;
    searchText: string;
    address: any = {};
    redirectBack: false;
    vehicleId: number;
    idCreated: number = 0;
    loading = false;
    public zoomLevel = 0;
    fitBoundsValue: boolean = true;
    userId: string;
    inputLocNote: string;
    options = {
        types: [],
        componentRestrictions: { country: "RSA" },
    };

    currentDate = new Date();
    updatePayload: any = {};
    createPayload: any = {};
    historyId: number = 0;
    context: string = "Updating";
    isEdit: boolean = false;
    imageUrl: string;
    hasControlTowerRole: boolean = false;
    hasManagerRole: boolean = false;
    typeId: number = 31;
    condition: boolean = false;
    isCustomsAction : boolean = false;
    tourType: string = "";
    private forceInputLocation = false;


    toggleFitBounds() {
        this.fitBoundsValue = !this.fitBoundsValue;
    }
    showDelivery: boolean = false;
    constructor(
        private dialog: MatDialog,
        private http: HttpClient,
        private dialogRef: MatDialogRef<UpdateEtaDialogComponent>,
        private store: Store,
        private mapsAPILoader: MapsAPILoader,
        private ngZone: NgZone,
        private actions$: Actions,
        private cdr: ChangeDetectorRef,
        @Inject(MAT_DIALOG_DATA) data: any
    ) {
        this.store.dispatch(new LoadUpdateTypesAction());
        this.isCustomsAction = data.isCustoms;
        this.forceInputLocation = !!data.forceInputLocation;
        this.tourType = data.tour.type;

        if (data.isCustoms) {
            this.updateTypes = [
                {
                    id: 3,
                    name: "Departed Loading point",
                    init: function (_data?: any): void {
                        throw new Error("Function not implemented.");
                    },
                    toJSON: function (data?: any) {
                        throw new Error("Function not implemented.");
                    },
                },
            ];
            this.updateType = 3;
            this.updateTypeConnection = [];
            this.loading = true;
            this.tourId = data.tourId;
            this.tour = data.tour;
            this.id = data.id;
            this.amcoId = data.amcoId;
            this.targetDates = data.targetDate;
            this.hasVehicle = data.hasVehicle;

            // Initialize other required properties
            this.targetDate = new Date(data.targetDate).toLocaleString(
                "en-US",
                {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                    hour12: true,
                }
            );

            this.plannedDeliveryStart = new Date(
                data.plannedDeliveryStart
            ).toLocaleString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
            });

            this.plannedDeliveryEnd = new Date(
                data.plannedDeliveryEnd
            ).toLocaleString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
            });

            this.plannedLoadingStart = new Date(
                data.plannedLoadingStart
            ).toLocaleString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
            });

            this.plannedLoadingEnd = new Date(
                data.plannedLoadingEnd
            ).toLocaleString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
            });

            this.OnChanges();
        } else {
            this.store.dispatch(
                new LoadUpdateTypesByParentIdAction({
                    parentId: data.updateTypeId,
                })
            );

            if (!data.isCustoms) {
                this.tourId = data.tourId;
                this.tour = data.tour;
                this.id = data.id;
                this.amcoId = data.amcoId;
                this.isEdit = data.isEdit;
                this.hasVehicle = data.hasVehicle;
                this.updateTypeId = data.updateTypeId;
                this.updateTypeName = data.updateTypeName;
                this.targetDates = data.targetDate;
                this.updatePolyline();
                this.redirectBack = data.redirectBack;
                this.vehicleId = data.vehicleId;
            }

            this.searchControl = new FormControl();
            this.searchLatLng = new FormControl();

            this.targetDate = new Date(data.targetDate).toLocaleString(
                "en-US",
                {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                    hour12: true,
                }
            );

            this.plannedDeliveryStart = new Date(
                data.plannedDeliveryStart
            ).toLocaleString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
            });

            this.plannedDeliveryEnd = new Date(
                data.plannedDeliveryEnd
            ).toLocaleString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
            });

            this.plannedLoadingStart = new Date(
                data.plannedLoadingStart
            ).toLocaleString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
            });

            this.plannedLoadingEnd = new Date(
                data.plannedLoadingEnd
            ).toLocaleString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
            });

            this.reasonsNgOnIt();

            if (data.vehicleTypes) {
                this.store.dispatch(
                    new GetVehicleSpeedByTypeAction(data.vehicleTypes)
                );
            }

            this.vehicleTypeSpeed$.pipe(take(1)).subscribe((speed) => {
                this.vehicleTypeSpeed = speed;
            });

            this.updateTypes$.subscribe((types) => {
                this.updateTypes = types;
                this.updateDropdown(data.updateTypeId);
            });

            this.updateTypesConnections$.subscribe((connections) => {
                this.updateTypeConnection = connections;
                this.updateDropdown(data.updateTypeId);
            });
        }

        if (data.isEdit) {
            this.context = "Editing";
            this.note = data.note;
            this.historyId = data.historyId;
            this.causeOfIssue = data.causeOfIssue;
            this.impactType = data.impact;
            this.reasonForIssueType = data.reasonForIssue;
            this.issueRaisedByCustomer = data.isLoggedByCustomer;
            this.hasCustomerBeenCalled = data.hasCustomerBeenCalled === true ? 'yes' : (data.hasCustomerBeenCalled === false ? 'no' : null);
            this.hasCarrierBeenCalled = data.hasCarrierBeenCalled === true ? 'yes' : (data.hasCarrierBeenCalled === false ? 'no' : null);
            this.escalateIssue = data.escalateIssue;
            const combinedDate = new Date(data.combinedDate);
            this.managerActions = data.managerActions;
            this.issueActions = data.issueActions;
            this.priority = data.priority;

            // Extract the date part
            const year = combinedDate.getFullYear();
            const month = String(combinedDate.getMonth() + 1).padStart(2, "0");
            const day = String(combinedDate.getDate()).padStart(2, "0");
            const dateString = `${year}-${month}-${day}`;
            this.selectedDate = new Date(dateString);

            // Extract the time part
            const hours = String(combinedDate.getHours()).padStart(2, "0");
            const minutes = String(combinedDate.getMinutes()).padStart(2, "0");
            this.targetTime = `${hours}:${minutes}`;
        }

        const token = this.store.selectSnapshot(AuthState.getDecodedToken);

        if (
            token.roles.findIndex(
                (hasRoleFn) => hasRoleFn === "ControlTowerUser"
            ) > -1
        ) {
            this.hasControlTowerRole = true;
        } else {
            this.hasControlTowerRole = false;
        }

        if (
            token.roles.findIndex((hasRoleFn) => hasRoleFn === "Manager") > -1
        ) {
            this.hasManagerRole = true;
        } else {
            this.hasManagerRole = false;
        }

    }

    zoomChange(zoom: number) {
        this.zoomLevel = zoom;
    }

    OnChanges(): void {
        var updateTypeSelected = this.updateTypes.filter(
            (x) => x.id == this.updateType
        );
        if (
            updateTypeSelected[0]?.name == "Loading delayed" ||
            updateTypeSelected[0]?.name == "Un-loading delayed"
        ) {
            this.addDates = false;
            this.addReason = false;
            this.addNotes = true;
            this.addInputLocation = false;
            this.inputLocationLoaded = false;
        } else if (updateTypeSelected[0]?.name == "Input location") {
            this.addRestDates = false;
            this.addNotes = true;
            if (this.hasVehicle) {
                this.addDates = !this.tour.isBmwJob;
                this.condition = true;
                this.addReason = false;
                this.addInputLocation = true;
                this.showCalBtn = true;

                setTimeout(() => {
                    if (!this.inputLocationLoaded) {
                        this.loadPlacesAutoComplete();
                        this.inputLocationLoaded = true;
                    }
                }, 1000);
            } else {
                this.addInputLocation = false;
                this.inputLocationLoaded = false;
                this.dialogRef.close();
                this.assignVehicle(this.id);
            }
        } else if (updateTypeSelected[0]?.name == "Driver Rest Start") {
            if (this.hasVehicle) {
                this.addRestDates = true;
                this.addInputLocation = true;
                this.addNotes = false;
                this.showCalBtn = false;
                this.addDates = false;
                this.addReason = false;
                this.showDelDates = false;

                setTimeout(() => {
                    if (!this.inputLocationLoaded) {
                        this.loadPlacesAutoComplete();
                        this.inputLocationLoaded = true;
                    }
                }, 1000);
            } else {
                this.addInputLocation = false;
                this.inputLocationLoaded = false;
                this.dialogRef.close();
                this.assignVehicle(this.id);
            }
            //auto show fields
            this.addRestDates = true;
            this.addInputLocation = true;
            this.addNotes = false;
            this.showCalBtn = false;
            this.addDates = false;
            this.addReason = false;
            this.showDelDates = false;
        } else if (updateTypeSelected[0]?.name == "Driver Rest end") {
            this.addRestDates = false;
            this.addInputLocation = true;
            this.addNotes = false;
            this.showCalBtn = false;
            this.addDates = true;
            this.addReason = false;
            this.showDelDates = false;
            this.condition = true;

            // Populate location from tour's vehicleLat/vehicleLng if available
            // This will trigger the existing blur handler to process it
            if (this.tour?.vehicleLat && this.tour?.vehicleLng && this.searchLatLng) {
                const latLngValue = `${this.tour.vehicleLat},${this.tour.vehicleLng}`;
                this.searchLatLng.setValue(latLngValue);

                // Trigger the distance calculation after a short delay to ensure form is ready
                setTimeout(() => {
                    this.calculateDistanceAndDuration();
                }, 600);
            }

            setTimeout(() => {
                if (!this.inputLocationLoaded) {
                    this.loadPlacesAutoComplete();
                    this.inputLocationLoaded = true;
                }
            }, 1000);
        } else if (updateTypeSelected[0]?.name == "Log an Issue") {
            this.addReason = true;
            this.addDates = false;
            this.addNotes = true;
            this.addInputLocation = false;
            this.addRestDates = false;
        } else if (updateTypeSelected[0]?.name == "On site Collection") {
            if (this.hasVehicle) {
                this.addDates = true;
                this.addNotes = true;
                this.addReason = false;
                this.addInputLocation = false;
                this.addRestDates = false;
            } else {
                this.dialogRef.close();
                this.assignVehicle(this.id);
            }
        } else if (updateTypeSelected[0]?.name == "On site Delivery") {
            if (this.hasVehicle) {
                this.addDates = true;
                this.addNotes = true;
                this.addReason = false;
                this.addInputLocation = false;
                this.addRestDates = false;
            } else {
                this.dialogRef.close();
                this.assignVehicle(this.id);
            }
        } else {
            this.addDates = true;
            this.addNotes = true;
            this.addReason = false;
            this.addInputLocation = false;
            this.addRestDates = false;
        }

        if (this.tour.type === "Delivery") {
            this.showDelivery = true;
        } else {
            this.showDelivery = false;
        }
    }

    ngAfterViewChecked() {
        if (this.addInputLocation && !this.inputLocationLoaded) {
            const inputElement = document.getElementById("search-input");
            if (inputElement) {
                if (!this.inputLocationLoaded) {
                    this.loadPlacesAutoComplete();
                    this.inputLocationLoaded = true;
                }
            }
        }
    }

    updatePolyline(): void {
        if (this.tour.vehicleLat) {
            this.polylinePoints = [
                { lat: this.tour.vehicleLat, lng: this.tour.vehicleLng },
                {
                    lat:
                        this.tour.type === "Collection"
                            ? this.tour.collectionLatitude
                            : this.tour.destinationLatitude,
                    lng:
                        this.tour.type === "Collection"
                            ? this.tour.collectionLongitude
                            : this.tour.destinationLongitude,
                },
            ];
        }
    }

    reasonsNgOnIt() {
        // Dispatch actions to load data
        this.store.dispatch(new LoadGetCauseOfIssueUpdateTypesAction());
        this.store.dispatch(new LoadGetImpactUpdateTypesAction());
        this.store.dispatch(new LoadGetReasonForIssueUpdateTypesAction());

        const sub1 = this.actions$
            .pipe(
                ofActionSuccessful(LoadGetCauseOfIssueUpdateTypesSuccessAction)
            )
            .subscribe(() => {
                this.causeOfIssueTypes$.subscribe((types) => {
                    this.causeOfIssueTypesList = types;
                });
            });

        const sub2 = this.actions$
            .pipe(ofActionSuccessful(LoadGetImpactUpdateTypesSuccessAction))
            .subscribe(() => {
                this.impactTypes$.subscribe((types) => {
                    this.impactTypesList = types;
                });
            });

        const sub3 = this.actions$
            .pipe(
                ofActionSuccessful(
                    LoadGetReasonForIssueUpdateTypesSuccessAction
                )
            )
            .subscribe(() => {
                this.reasonForIssueTypes$.subscribe((types) => {
                    this.reasonForIssueTypesList = types;
                });
            });
    }

    onMapClick(event: any) {
        const lat = event.coords.lat;
        const lng = event.coords.lng;
        this.searchLatLng.setValue(`${lat},${lng}`);

        this.calculateDistanceAndDuration();
    }

    openEmailDialog() {
        const dialogRef = this.dialog.open(EditContactPersonDialogComponent, {
            data: { editTourId: this.tour.tourId, transportOrderNumber: this.tour.transportOrderNumber }, disableClose: true, width: '1000px'
        });

        dialogRef.afterClosed().subscribe(result => {
            this.store.dispatch(new GetTourByIdAction(this.tour.tourId, this.tour.transportOrderNumber));
        });
    }

    saveRoute() {
        var tourId = this.id;
        var vehicleId = this.redirectBack
            ? this.vehicleId
            : this.tour.vehicleId;
        var routeData = JSON.stringify(this.polylinePoints);

        var distance = this.tour.vehicleDistance;
        var updateTypeSelected = this.updateTypes.filter(
            (x) => x.id == this.updateType
        );
        var typeSelected = updateTypeSelected[0]?.name;

        //suggested eta
        const parts =
            this.tour.vehicleDuration !== null &&
            this.tour.vehicleDuration !== undefined &&
            this.tour.vehicleDuration.trim() !== ""
                ? this.tour.vehicleDuration.split(" ")
                : "50 mins".split(" ");

        let vehicleHours = 0;
        let vehicleMinutes = 0;

        // Iterate through each part to find hours and minutes
        // since it comes as 2 hours 5 min
        for (let i = 0; i < parts.length; i++) {
            const part = parts[i].toLowerCase();

            if (part.includes("hour")) {
                if (i > 0 && !isNaN(parseInt(parts[i - 1], 10))) {
                    vehicleHours += parseInt(parts[i - 1], 10);
                } else {
                    vehicleHours += parseInt(part, 10);
                }
            } else if (part.includes("min")) {
                if (i > 0 && !isNaN(parseInt(parts[i - 1], 10))) {
                    vehicleMinutes += parseInt(parts[i - 1], 10);
                } else {
                    vehicleMinutes += parseInt(part, 10);
                }
            }
        }

        // Adjust hours if minutes exceed 59
        if (vehicleMinutes >= 60) {
            const additionalHours = Math.floor(vehicleMinutes / 60);
            vehicleHours += additionalHours;
            vehicleMinutes %= 60;
        }

        const selectedDateTime = new Date(this.selectedDate);

        selectedDateTime.setHours(selectedDateTime.getHours() + vehicleHours);
        selectedDateTime.setMinutes(
            selectedDateTime.getMinutes() + vehicleMinutes
        );

        var suggestedEta = selectedDateTime;

        this.store.dispatch(
            new SaveRouteAction(
                tourId,
                vehicleId,
                routeData,
                typeSelected,
                suggestedEta,
                distance
            )
        );
    }

    assignVehicle(tourid: any) {
        var updateTypeSelected = this.updateTypes.filter(
            (x) => x.id == this.updateType
        );
        var typeSelected = updateTypeSelected[0]?.name;
        var typeId = updateTypeSelected[0]?.id;
        const dialogRef = this.dialog.open(AssignVehicleDialogComponent, {
            data: {
                tour: this.tour,
                id: tourid,
                redirectBack: true,
                tourId: this.tourId,
                updateTypeId: typeId,
                updateTypeName: typeSelected,
                amcoId: this.amcoId,
                targetDateTime: this.targetDates,
                plannedDeliveryStart: this.plannedDeliveryStart,
                plannedDeliveryEnd: this.plannedDeliveryEnd,
                plannedLoadingStart: this.plannedLoadingStart,
                plannedLoadingEnd: this.plannedLoadingEnd,
            },
        });

        dialogRef.afterClosed().subscribe((result) => {});
    }

    loadPlacesAutoComplete() {
        this.mapsAPILoader.load().then(() => {
            const inputElement: HTMLInputElement = document.getElementById(
                "search-input"
            ) as HTMLInputElement;
            const inputLatLngElement: HTMLInputElement =
                document.getElementById(
                    "search-input-latlng"
                ) as HTMLInputElement;

            const autocomplete = new google.maps.places.Autocomplete(
                inputElement
            );
            autocomplete.setFields(["name", "formatted_address", "geometry"]);
            //  Observable to event listener
            google.maps.event.addListener(autocomplete, "place_changed", () => {
                const place: google.maps.places.PlaceResult =
                    autocomplete.getPlace();
                // Do not remove the below - this audits everytime we get a place from google
                var updateTypeSelected = this.updateTypes.filter(
                    (x) => x.id == this.updateType
                );
                this.store.dispatch(
                    new AuditGoogleApiAction(updateTypeSelected[0]?.name)
                );

                if (!place?.geometry) {
                    console.log("Place not found");
                    return;
                }

                if (place.geometry.location) {
                    this.places = {
                        name: place.name,
                        address: place.formatted_address,
                        location: {
                            lat: place.geometry.location.lat(),
                            lng: place.geometry.location.lng(),
                        },
                    };
                    this.calculateDistanceAndDuration();
                    this.showMap(place.geometry.location);
                    this.latitude = place.geometry.location.lat();
                    this.longitude = place.geometry.location.lng();
                } else if (inputLatLngElement.value) {
                    const [lat, lng] = inputLatLngElement.value
                        .split(",")
                        .map((coord) => parseFloat(coord.trim()));

                    if (!isNaN(lat) && !isNaN(lng)) {
                        this.handleCoordinates(lat, lng);
                    } else {
                        console.log("Invalid latitude or longitude");
                    }
                } else {
                    console.log("No valid input");
                }

                // Clear both inputs
                this.searchControl.setValue("");
                this.searchLatLng.setValue("");
            });
        });
    }

    showMap(location: google.maps.LatLng) {
        this.tour.vehicleLat = location.lat();
        this.tour.vehicleLng = location.lng();
        const mapOptions: google.maps.MapOptions = {
            center: location,
            zoom: 5,
        };

        this.updatePolyline();

        this.searchLatLng.setValue(`${location.lat()},${location.lng()}`);
        this.map = new google.maps.Map(this.mapElement, mapOptions);

        // Add a marker for the selected place
        this.marker = new google.maps.Marker({
            position: location,
            map: this.map,
            title: this.places.address,
            draggable: true,
        });
        // Add a dragend event listener to update the location when marker is dragged
        google.maps.event.addListener(this.marker, "dragend", () => {
            const newPosition = this.marker!.getPosition();
            if (newPosition) {
                this.places.location = {
                    lat: newPosition.lat(),
                    lng: newPosition.lng(),
                };
            }
        });
    }

    geocodeLatLng() {
        if (this.searchLatLng.value) {
            const input = this.searchLatLng.value.trim();
            const latlngStr = input.split(",", 2);
            const latlng = {
                lat: parseFloat(latlngStr[0]),
                lng: parseFloat(latlngStr[1]),
            };

            this.handleCoordinates(latlng.lat, latlng.lng);
        }
    }

    handleCoordinates(latitude: number, longitude: number) {
        const geocoder = new google.maps.Geocoder();
        const location = new google.maps.LatLng(latitude, longitude);

        geocoder.geocode({ location: location }, (results, status) => {
            if (status === "OK" && results[0]) {
                const address = results[0].formatted_address;

                this.searchControl.setValue(address);
                this.places = {
                    name: "Lat Long input Location",
                    address: address,
                    location: {
                        lat: latitude,
                        lng: longitude,
                    },
                };
            } else {
                console.error("Geocoder failed with status:", status);
            }
        });
        this.showMap(location);
    }

    resetMap() {
        this.places = null;
        this.tour.vehicleDistance = null;
        this.tour.vehicleDuration = null;

        this.tour.vehicleLat = null;
        this.tour.vehicleLng = null;
        this.polylinePoints = [];
    }

    calculateDistanceAndDuration() {
        // Default UK speed: 50 km/h (approximately 31 mph) - typical for commercial vehicles
        const DEFAULT_UK_SPEED = 50;

        // Get speed from vehicleTypeSpeed or use default
        const speed = (this.vehicleTypeSpeed?.speed != null && this.vehicleTypeSpeed.speed !== undefined)
            ? this.vehicleTypeSpeed.speed
            : DEFAULT_UK_SPEED;

        if (this.searchLatLng.value) {
            const input = this.searchLatLng.value.trim();
            if (input) {
                const coordinates = input.split(",");
                this.tour.vehicleLat = parseFloat(coordinates[0].trim());
                this.tour.vehicleLng = parseFloat(coordinates[1].trim());

                this.store.dispatch(
                    new CalculateDistanceAction(
                        this.tour.vehicleLat != null
                            ? this.tour.vehicleLat
                            : 0.0,
                        this.tour.vehicleLng != null
                            ? this.tour.vehicleLng
                            : 0.0,
                        this.tour.type === "Collection"
                            ? this.tour.collectionLatitude
                            : this.tour.destinationLatitude,
                        this.tour.type === "Collection"
                            ? this.tour.collectionLongitude
                            : this.tour.destinationLongitude,
                        speed
                    )
                );
                const sub = this.actions$
                    .pipe(ofActionSuccessful(CalculateDistanceSuccessAction))
                    .subscribe((resp: any) => {
                        this.tour.vehicleDistance = resp.distanceModel.distance;
                        this.tour.vehicleDuration = resp.distanceModel.duration;

                        //update polylines and save route
                        this.updatePolyline();

                        //get address from geocode
                        this.geocodeLatLng();
                        sub.unsubscribe();
                    });
            } else {
                console.error("Invalid input for latitude and longitude");
            }
        } else {
            this.store.dispatch(
                new CalculateDistanceAction(
                    this.tour.vehicleLat != null ? this.tour.vehicleLat : 0.0,
                    this.tour.vehicleLng != null ? this.tour.vehicleLng : 0.0,
                    this.tour.type === "Collection"
                        ? this.tour.collectionLatitude
                        : this.tour.destinationLatitude,
                    this.tour.type === "Collection"
                        ? this.tour.collectionLongitude
                        : this.tour.destinationLongitude,
                    speed
                )
            );
            const sub = this.actions$
                .pipe(ofActionSuccessful(CalculateDistanceSuccessAction))
                .subscribe((resp: any) => {
                    this.tour.vehicleDistance = resp.distanceModel.distance;
                    this.tour.vehicleDuration = resp.distanceModel.duration;

                    //update polylines and save route
                    this.updatePolyline();
                    sub.unsubscribe();
                });
        }
    }

    onVehicleMarkerDragEnd(event: any): void {
        // Handle the new position of the vehicle marker after dragging
        this.tour.vehicleLat = event.coords.lat;
        this.tour.vehicleLng = event.coords.lng;
        this.calculateDistanceAndDuration();
        this.updatePolyline();
    }

    onCancelClick(): void {
        this.resetMap();
        this.clearDialogData();
        this.store.dispatch(new ClearSelectedTourAction());
        this.dialogRef.close();
    }

    clearDialogData(): void {
        // Clear date/time data only - this prevents validation errors
        this.selectedDate = null;
        this.restStartDate = null;
        this.restEndDate = null;
        this.restStartTargetTime = '';
        this.restEndTargetTime = '';
        this.targetDate = '';
        this.targetDates = '';
        this.targetTime = '';
        this.targetDateOnly = null;
        this.plannedDeliveryStart = null;
        this.plannedDeliveryEnd = null;
        this.plannedLoadingStart = null;
        this.plannedLoadingEnd = null;
    }

    clearDialogDataExcludingIssues(): void {
        // Clear date/time data only - this prevents validation errors
        this.selectedDate = null;
        this.restStartDate = null;
        this.restEndDate = null;
        this.restStartTargetTime = '';
        this.restEndTargetTime = '';
        this.targetDate = '';
        this.targetDates = '';
        this.targetTime = '';
        this.targetDateOnly = null;
        this.plannedDeliveryStart = null;
        this.plannedDeliveryEnd = null;
        this.plannedLoadingStart = null;
        this.plannedLoadingEnd = null;
    }

    validateUpdate(
        updateType: string,
        combinedDateTime: Date,
        restEndDateTime: Date,
        tour: any
    ): boolean {
        const plannedLoadingEnd = new Date(tour.plannedLoadingEnd);
        const plannedDeliveryEnd = new Date(tour.plannedDeliveryEnd);

        let validationText = "";
        let subConfirmationText = "";

        if (
            updateType === "ETA to collection" &&
            combinedDateTime > plannedLoadingEnd
        ) {
            validationText = "ETA to collection entered is after planned time";
        } else if (
            updateType === "On site Collection" &&
            combinedDateTime > plannedLoadingEnd
        ) {
            validationText =
                "On site Collection entered is after planned collection time";
        } else if (
            updateType === "ETA to delivery" &&
            combinedDateTime > plannedDeliveryEnd
        ) {
            validationText =
                "ETA to delivery entered is after planned delivery time";
        } else if (
            updateType === "On site Delivery" &&
            combinedDateTime > plannedDeliveryEnd
        ) {
            validationText =
                "On site delivery date entered is after planned delivery time";
        } else if (
            updateType === "Driver Rest end" &&
            ((tour.type === "Collection" &&
                combinedDateTime > plannedLoadingEnd) ||
                (tour.type === "Delivery" &&
                    combinedDateTime > plannedDeliveryEnd))
        ) {
            validationText =
                "Driver rest end date entered is after planned time";
        } else if (
            updateType === "Input location" &&
            ((tour.type === "Collection" &&
                combinedDateTime > plannedLoadingEnd) ||
                (tour.type === "Delivery" &&
                    combinedDateTime > plannedDeliveryEnd))
        ) {
            validationText =
                "ETA entered on input location is after planned time";
        }

        if (validationText) {
            this.openValidationDialog(
                validationText,
                combinedDateTime,
                restEndDateTime,
                tour
            );
            return true;
        } else {
            return false;
        }
    }

    openValidationDialog(
        subConfirmationText: string,
        combinedDateTime: Date,
        restEndDateTime: Date,
        tour: any
    ): void {
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            data: {
                modalTitle: "Validation",
                buttonType: "YesValidation",
                confirmationText:
                    "Are you sure you have updated the right job with the right information?",
                subConfirmationText: subConfirmationText,
            },
        });

        dialogRef.afterClosed().subscribe((result) => {
            var updateTypeSelected = this.updateTypes.filter(
                (x) => x.id == this.updateType
            );

            if (result) {
                this.updatePayload = {
                    tourId: this.isEdit ? this.historyId : tour.id,
                    note: this.note,
                    isApproved: false,
                    requiresValidation: true,
                    rejectionComments: "",
                    updateTypeLookupId: this.isEdit
                        ? 0
                        : updateTypeSelected[0]?.id,
                    eta:
                        updateTypeSelected[0]?.name == "Driver Rest end"
                            ? restEndDateTime
                            : combinedDateTime,
                    isEdit: this.isEdit,
                };

                this.createPayload = {
                    tourId: this.isEdit ? this.historyId : tour.id,
                    note: this.note,
                    isApproved: false,
                    requiresValidation: true,
                    rejectionComments: "",
                    updateTypeLookupId: this.isEdit
                        ? 0
                        : updateTypeSelected[0]?.id,
                    eta:
                        updateTypeSelected[0]?.name == "Driver Rest end"
                            ? restEndDateTime
                            : combinedDateTime,
                    isEdit: this.isEdit,
                    vehicleLat: this.tour.vehicleLat,
                    vehicleLng: this.tour.vehicleLng,
                    vehicleDur: this.tour.vehicleDuration,
                    vehicleDistance: this.tour.vehicleDistance,
                    place: this.places.address,
                };
                if (this.isEdit) {
                    this.store.dispatch(
                        new UpdateHistoryItemByIdAction(this.updatePayload)
                    );
                } else {
                    this.store.dispatch(
                        new CreateTourHistoryByTourIdAction(
                            updateTypeSelected[0]?.name == "Input location" ||
                            "Driver Rest end"
                                ? this.createPayload
                                : this.updatePayload
                        )
                    );
                }

                this.store.dispatch(new ClearSelectedTourAction());
                this.dialog.closeAll();
                this.refreshClick();
            }
        });
    }

    onSaveClick(): void {
        if (this.isCharacterLimitExceeded()) {
            const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
                data: {
                    modalTitle: "Character Limit Exceeded",
                    buttonType: "OK",
                    confirmationText: `The total character count (${this.getTotalCharacterCount()}) exceeds the limit of 1500 characters. Please reduce the text in one or more fields.`
                },
            });
            return;
        }

        // Check if customer contact email is still not set
        if (!this.tour?.customerContactEmail || this.tour.customerContactEmail.trim() === '') {
            const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
                data: {
                    modalTitle: "Warning",
                    buttonType: "Continue",
                    submitTitle: "Continue",
                    confirmationText: "This customer has no contact details loaded. Manual updates required. Do you want to continue with saving?"
                },
            });

            dialogRef.afterClosed().subscribe((result) => {
                if (result) {
                    this.proceedWithSave();
                }
            });
            return;
        }

        // If email is set, proceed with normal save flow
        this.proceedWithSave();
    }

    private proceedWithSave(): void {

        if (this.updateTypes[0]?.name === "Departed Loading point" && this.isCustomsAction) {
            let combinedDateTime: Date;

            // Create the combined date time from selected date and time
            if (this.selectedDate && this.targetTime) {
                const [hours, minutes] = this.targetTime.split(":").map(Number);
                combinedDateTime = new Date(this.selectedDate);
                combinedDateTime.setHours(hours);
                combinedDateTime.setMinutes(minutes);

                // Dispatch the update action
                this.store.dispatch(
                    new UpdateCustomByTourIdAction(
                        this.tourId,
                        combinedDateTime,
                        this.updateType,
                        this.note || ''
                    )
                );
                this.store.dispatch(new ClearSelectedTourAction());
                this.clearDialogData();
                this.dialogRef.close(true);
                return;
            }
            return;
        }

        let combinedDateTime: Date;
        let restStartDateTime: Date;
        let restEndDateTime: Date;
        var updateTypeSelected = this.updateTypes.filter(
            (x) => x.id == this.updateType
        );
        const isBmwInputLocation = this.tour.isBmwJob && updateTypeSelected[0]?.name === "Input location";
        if (isBmwInputLocation) {
            // The API ignores this required transport value for BMW location-only updates.
            combinedDateTime = new Date();
        } else if (
            updateTypeSelected[0]?.name != "Log an Issue" &&
            updateTypeSelected[0]?.name != "Loading delayed" &&
            updateTypeSelected[0]?.name != "Un-loading delayed" &&
            updateTypeSelected[0]?.name != "Driver Rest Start"
        ) {
            const [hours, minutes] = this.targetTime.split(":").map(Number);
            combinedDateTime = new Date(this.selectedDate);
            combinedDateTime.setHours(hours);
            combinedDateTime.setMinutes(minutes);
        }

        if (updateTypeSelected[0]?.name == "Driver Rest Start") {
            const [hours, minutes] = this.restStartTargetTime
                .split(":")
                .map(Number);
            restStartDateTime = new Date(this.restStartDate);
            restStartDateTime.setHours(hours);
            restStartDateTime.setMinutes(minutes);

            const [hr, min] = this.restEndTargetTime.split(":").map(Number);
            restEndDateTime = new Date(this.restEndDate);
            restEndDateTime.setHours(hr);
            restEndDateTime.setMinutes(min);
        } else if (updateTypeSelected[0]?.name == "Driver Rest end") {
            const [hr, min] = this.targetTime.split(":").map(Number);
            restEndDateTime = new Date(this.selectedDate);
            restEndDateTime.setHours(hr);
            restEndDateTime.setMinutes(min);
        } else {
            restStartDateTime = new Date();
            restEndDateTime = new Date();
        }

        if (updateTypeSelected[0]?.name == "Driver Rest end") {
            this.saveRoute();
        }

        if (updateTypeSelected[0]?.name == "Input location") {
            this.note = this.note;
            if (!isBmwInputLocation) {
                this.saveRoute();
            }
        }
        if (
            isBmwInputLocation ||
            this.selectedDate ||
            updateTypeSelected[0]?.name == "Log an Issue" ||
            updateTypeSelected[0]?.name == "Loading delayed" ||
            updateTypeSelected[0]?.name == "Un-loading delayed" ||
            updateTypeSelected[0]?.name == "Driver Rest Start" ||
            updateTypeSelected[0]?.name == "Driver Rest end"
        ) {
            if (
                updateTypeSelected[0]?.name != "Input location" &&
                updateTypeSelected[0]?.name != "Driver Rest Start" &&
                updateTypeSelected[0]?.name != "Driver Rest end"
            ) {
                this.places = {
                    name: "null",
                    address: "",
                    location: {
                        lat: 0,
                        lng: 0,
                    },
                };
            }

            //Validation Rules
            const requiresValidation = !isBmwInputLocation && this.validateUpdate(
                updateTypeSelected[0]?.name,
                combinedDateTime,
                restEndDateTime,
                this.tour
            );

            if (!requiresValidation) {
                const sub = this.actions$
                    .pipe(ofActionSuccessful(UpdateETASuccessAction))
                    .subscribe((detail) => {
                        this.idCreated = detail.payload?.tour?.tourHistoryId;
                    });

                this.store.dispatch(
                    new UpdateETAAction(
                        this.tourId,
                        combinedDateTime,
                        this.updateType,
                        this.note,
                        this.tour.vehicleLat,
                        this.tour.vehicleLng,
                        this.tour.vehicleDuration,
                        this.tour.vehicleDistance,
                        this.places.address,
                        restStartDateTime,
                        restEndDateTime,
                        this.historyId,
                        this.tour?.transportOrderNumber
                    )
                );
                this.store.dispatch(new ClearSelectedTourAction());
                this.clearDialogDataExcludingIssues();
                this.dialog.closeAll();
            }
            if (updateTypeSelected[0]?.name == "Log an Issue") {
                combinedDateTime = new Date();

                if (this.note === null) {
                    this.note = "";
                }

                if (this.isEdit) {
                    if (this.tour.isTourEscalated) {
                        this.escalateIssue = false;
                        this.store.dispatch(
                            new LogAnIssueAction(
                                this.id,
                                this.causeOfIssue,
                                this.impactType,
                                this.reasonForIssueType,
                                this.issueRaisedByCustomer,
                                this.hasCustomerBeenCalled === 'yes',
                                this.hasCarrierBeenCalled === 'yes',
                                this.note,
                                combinedDateTime,
                                this.historyId,
                                this.idCreated,
                                this.issueStatus == "open" ? true : false,
                                this.escalateIssue,
                                this.hasControlTowerRole,
                                this.managerActions,
                                this.issueActions,
                                this.priority
                            )
                            );
                        this.store.dispatch(new ClearSelectedTourAction());
                        this.clearDialogDataExcludingIssues();
                        this.dialog.closeAll();
                    } else {
                        const dialogRef = this.dialog.open(
                            ConfirmationDialogComponent,
                            {
                                data: {
                                    modalTitle: "Escalate Issue",
                                    buttonType: "Escalate",
                                    confirmationText:
                                        "Do you want to escalate this issue ?",
                                },
                            }
                        );

                        dialogRef.afterClosed().subscribe((result) => {
                            this.escalateIssue = result;
                            this.store.dispatch(
                                new LogAnIssueAction(
                                    this.id,
                                    this.causeOfIssue,
                                    this.impactType,
                                    this.reasonForIssueType,
                                    this.issueRaisedByCustomer,
                                    this.hasCustomerBeenCalled === 'yes',
                                    this.hasCarrierBeenCalled === 'yes',
                                    this.note,
                                    combinedDateTime,
                                    this.historyId,
                                    this.idCreated,
                                    this.issueStatus == "open" ? true : false,
                                    this.escalateIssue,
                                    this.hasControlTowerRole,
                                    this.managerActions,
                                    this.issueActions,
                                    this.priority
                                )
                            );
                            this.store.dispatch(new ClearSelectedTourAction());
                            this.clearDialogDataExcludingIssues();
                            this.dialog.closeAll();
                        });
                    }
                } else {
                    const dialogRef = this.dialog.open(
                        ConfirmationDialogComponent,
                        {
                            data: {
                                modalTitle: "Escalate Issue",
                                buttonType: "Escalate",
                                confirmationText:
                                    "Do you want to escalate this issue ?",
                            },
                        }
                    );

                    dialogRef.afterClosed().subscribe((result) => {
                        this.escalateIssue = result;
                        this.store.dispatch(
                            new LogAnIssueAction(
                                this.id,
                                this.causeOfIssue,
                                this.impactType,
                                this.reasonForIssueType,
                                this.issueRaisedByCustomer,
                                this.hasCustomerBeenCalled === 'yes',
                                this.hasCarrierBeenCalled === 'yes',
                                this.note,
                                combinedDateTime,
                                this.historyId,
                                this.idCreated,
                                this.issueStatus == "open" ? true : false,
                                this.escalateIssue,
                                this.hasControlTowerRole,
                                this.managerActions,
                                this.issueActions,
                                this.priority
                            )
                        );
                        this.store.dispatch(new ClearSelectedTourAction());
                        this.clearDialogDataExcludingIssues();
                        this.dialog.closeAll();
                    });
                }
            }
        } else {
            // error handling
        }
    }

    onDateChange() {
        this.combineDateTime();
    }

    getIcon(type: string, updatedBy: string): string {
        if (updatedBy == "ImportService") {
            return type == "Collection"
                ? "./assets/images/White-C.png"
                : "./assets/images/White-D.png";
        } else {
            return type == "Collection"
                ? "./assets/images/Green-C.png"
                : "./assets/images/Green-D.png";
        }
    }

    getTruckIcon(planned: string, eta?: Date, actual?: Date): string {
        const plannedDate = new Date(planned);
        const etaOrActual = eta || actual;

        if (!etaOrActual) {
            // No ETA or actual time entered
            return "./assets/images/amco-main-bw.png";
        }

        if (etaOrActual > plannedDate) {
            // ETA or actual time is after the planned time
            return "./assets/images/amco-red-truck.png";
        }

        // ETA or actual time is before or on the planned time
        return "./assets/images/amco-green-truck.png";
    }

    getCollectionIcon(
        planned: string,
        eta?: Date,
        actual?: Date,
        type?: string
    ): string {
        const plannedDate = new Date(planned);
        const etaOrActual = eta || actual;
        const ActualDateTime = actual;
        const ETA = eta;

        if (!etaOrActual) {
            // No ETA or actual time entered
            return "./assets/images/collect-base.png";
        }

        if (type == "Delivery") {
            if (ActualDateTime > plannedDate) {
                // ETA or actual time is after the planned time
                return "./assets/images/collect-1.png";
            } else {
                return "./assets/images/collect-2.png";
            }
        }

        if (etaOrActual > plannedDate) {
            // ETA or actual time is after the planned time
            return "./assets/images/collect-1.png";
        }

        // ETA or actual time is before or on the planned time
        return "./assets/images/collect-2.png";
    }

    getDeliveryIcon(planned: string, eta?: Date, actual?: Date): string {
        const plannedDate = new Date(planned);
        const etaOrActual = eta || actual;

        if (!etaOrActual) {
            // No ETA or actual time entered
            return "./assets/images/delivery-base.png";
        }

        if (etaOrActual > plannedDate) {
            // ETA or actual time is after the planned time
            return "./assets/images/delivery-1.png";
        }

        // ETA or actual time is before or on the planned time
        return "./assets/images/delivery-2.png";
    }

    onMapReady(map: any): void {
        const trafficLayer = new google.maps.TrafficLayer();
        trafficLayer.setMap(map);
    }

    getTimeDifference(targetDateTime: string, ETADateTime: Date): string {
        const targetDate = new Date(targetDateTime);

        if (!ETADateTime) {
            //no eta then Delta should be blank
            return "";
        } else {
            // If ETA exists, calculate time difference between ETA and planned end
            const ETADate = new Date(ETADateTime);
            const timeDifference = Math.abs(
                ETADate.getTime() - targetDate.getTime()
            );
            const minutesDifference = Math.floor(timeDifference / (1000 * 60));

            const hours = Math.floor(minutesDifference / 60);
            const minutes = minutesDifference % 60;

            if (hours === 0 && minutes === 0) {
                return "0 hrs";
            }

            let timeDifferenceString = "";

            if (hours > 0) {
                timeDifferenceString += hours + "hr ";
            }
            if (minutes > 0) {
                timeDifferenceString += minutes + "min";
            }

            return timeDifferenceString.trim();
        }
    }

    //workflow update type
    updateDropdown(parentId: string) {
        if (this.forceInputLocation) {
            const inputLocationType = this.updateTypes?.find(
                (x) => x.name === "Input location"
            );
            if (inputLocationType) {
                this.updateTypes = [inputLocationType];
                setTimeout(() => {
                    this.updateType = inputLocationType.id;
                    this.OnChanges();
                    this.loading = true;
                }, 100);
            }
            return;
        }
        if (this.updateTypes && this.updateTypeConnection) {
            var updateTypev = this.updateTypes.filter(
                (x) => x.id == parseInt(parentId)
            );
            const connections = this.updateTypeConnection.filter(
                (conn) => parseInt(conn.parentId) === parseInt(parentId)
            );

            if (connections && connections.length > 0) {
                const childIds = connections.flatMap(
                    (conn) => conn.childId?.split(",").map((id) => +id) || []
                );

                const filteredTypes = this.updateTypes.filter((type) => {
                    const typeId = +type.id;
                    return childIds.includes(typeId);
                });

                this.updateTypes = filteredTypes;
            }
            setTimeout(() => {
                this.updateType = this.redirectBack
                    ? updateTypev[0].id
                    : parseInt(parentId);
                this.OnChanges();
                this.loading = true;
            }, 100);
        }
    }

    onTimeChange() {
        this.combineDateTime();
    }

    combineDateTime() {
        if (this.targetDateOnly && this.targetTime) {
            const localDateTime = new Date(
                this.targetDateOnly.getFullYear(),
                this.targetDateOnly.getMonth(),
                this.targetDateOnly.getDate(),
                parseInt(this.targetTime.split(":")[0], 10),
                parseInt(this.targetTime.split(":")[1], 10)
            );

            this.selectedDate = new Date(localDateTime.toUTCString());
        }
    }

    refreshClick() {
        this.loadDashboard();
        this.loadTours();
    }

    loadTours() {
        this.store.dispatch(new LoadTourListAction());
    }

    loadDashboard() {
        this.store.dispatch(new LoadDashboardsAction());
    }

    isDriverRestEnd(): boolean {
        if (this.updateTypes && this.updateType) {
            const updateTypeSelected = this.updateTypes.filter(
                (x) => x.id == this.updateType
            );
            return updateTypeSelected[0]?.name == "Driver Rest end";
        }
        return false;
    }

    getTotalCharacterCount(): number {
        const noteCount = (this.note || '').length;
        const managerActionsCount = (this.managerActions || '').length;
        const issueActionsCount = (this.issueActions || '').length;
        return noteCount + managerActionsCount + issueActionsCount;
    }

    getRemainingCharacters(): number {
        const maxCharacters = 1500;
        return maxCharacters - this.getTotalCharacterCount();
    }

    isCharacterLimitExceeded(): boolean {
        return this.getTotalCharacterCount() > 1500;
    }

    onNoteInput(event: any): void {
        const currentTotal = this.getTotalCharacterCount();
        if (currentTotal > 1500) {
            const otherFieldsLength = (this.managerActions || '').length + (this.issueActions || '').length;
            const maxNoteLength = 1500 - otherFieldsLength;
            if (maxNoteLength >= 0) {
                this.note = this.note.substring(0, maxNoteLength);
            } else {
                this.note = '';
            }
        }
    }

    onManagerActionsInput(event: any): void {
        const currentTotal = this.getTotalCharacterCount();
        if (currentTotal > 1500) {
            const otherFieldsLength = (this.note || '').length + (this.issueActions || '').length;
            const maxManagerActionsLength = 1500 - otherFieldsLength;
            if (maxManagerActionsLength >= 0) {
                this.managerActions = this.managerActions.substring(0, maxManagerActionsLength);
            } else {
                this.managerActions = '';
            }
        }
    }

    onIssueActionsInput(event: any): void {
        const currentTotal = this.getTotalCharacterCount();
        if (currentTotal > 1500) {
            const otherFieldsLength = (this.note || '').length + (this.managerActions || '').length;
            const maxIssueActionsLength = 1500 - otherFieldsLength;
            if (maxIssueActionsLength >= 0) {
                this.issueActions = this.issueActions.substring(0, maxIssueActionsLength);
            } else {
                this.issueActions = '';
            }
        }
    }

    isFormValid(): boolean {
        // Customize this logic based on your requirements
        if (this.updateTypes) {
            var updateTypeSelected = this.updateTypes.filter(
                (x) => x.id == this.updateType
            );
            if (updateTypeSelected[0]?.name == "Log an Issue") {
                return !!this.hasCustomerBeenCalled && !!this.hasCarrierBeenCalled;
            } else if (updateTypeSelected[0]?.name == "Loading delayed") {
                return true;
            } else if (updateTypeSelected[0]?.name == "ETA to collection") {
                return this.selectedDate && this.targetTime ? true : false;
            } else if (updateTypeSelected[0]?.name == "On site Collection") {
                return this.selectedDate && this.targetTime ? true : false;
            } else if (
                updateTypeSelected[0]?.name == "Departed Loading point"
            ) {
                return this.selectedDate && this.targetTime ? true : false;
            } else if (
                updateTypeSelected[0]?.name == "Departed unloading point"
            ) {
                return this.selectedDate && this.targetTime ? true : false;
            } else if (updateTypeSelected[0]?.name == "ETA to delivery") {
                return this.selectedDate && this.targetTime ? true : false;
            } else if (updateTypeSelected[0]?.name == "On site Delivery") {
                return this.selectedDate && this.targetTime ? true : false;
            } else if (updateTypeSelected[0]?.name == "Un-loading delayed") {
                return true;
            } else if (updateTypeSelected[0]?.name == "Awaiting POD") {
                return this.selectedDate && this.targetTime ? true : false;
            } else if (updateTypeSelected[0]?.name == "Driver Rest end") {
                return this.searchControl.value &&
                    this.selectedDate &&
                    this.targetTime
                    ? true
                    : false;
            } else if (updateTypeSelected[0]?.name == "Driver Rest Start") {
                return (this.searchControl.value && this.restEndTargetTime) ||
                    (this.restEndTargetTime && this.searchLatLng.value)
                    ? true
                    : false;
            } else if (updateTypeSelected[0]?.name == "Input location") {
                if (this.hasVehicle) {
                    if (this.tour.isBmwJob) {
                        return this.tour.vehicleLat != null && this.tour.vehicleLng != null;
                    }
                    var latlng = this.tour.vehicleLat
                        ? true
                        : false && this.tour.vehicleLng
                        ? true
                        : false;
                    return this.selectedDate && latlng && this.targetTime
                        ? true
                        : false;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        }
    }
}
